import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import { useNavigate } from 'react-router';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useAuth } from '../../contexts/authWindows';
import { UserRoles } from '../../types/core/auth.types';
import { paths } from '../../utils/core/routes';
import { AssetList } from './AssetList';

export function AssetPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(paths.ASSETS_CREATE);
      }}
    >
      <AddIcon />
    </Fab>,
  ];
  const isReadOnly = user?.roles.includes(UserRoles.Admin) ? false : true;
  return (
    <>
      <PageHeader title={'Assets'} buttons={isReadOnly ? null : headerButtons} xs={6} />
      <PageContent>
        <AssetList isReadOnly={isReadOnly} />
      </PageContent>
    </>
  );
}
